<template>
  <div>
    <!-- Table Container Card -->
    <b-card
        no-body
        class="mb-0"
    >
      <div class="m-2">
        <h2 class="text-center mb-4"> {{ tanggal }}</h2>
        <b-table
            small
            :fields="fields"
            :items="items"
            responsive="sm"
        >
          <!-- A virtual column -->
          <template #cell(#)="data">
            {{ data.index + 1 }}
          </template>

          <!-- A custom formatted column -->
          <template #cell(nama)="data">
            {{ data.item.nip + ' - ' + data.value }}
          </template>

          <!-- A custom formatted column -->
          <template #cell(alfa)="data">
            <b-form-radio
                v-model="selected[data.index]"
                :name="'kehadiran['+data.index+']'"
                value="alfa"
                :checked="data.value"
                :disabled="!data.item.editable"
                class="custom-control-danger"
            >
            </b-form-radio>
          </template>

          <!-- A custom formatted column -->
          <template #cell(hadir)="data">
            <b-form-radio
                v-model="selected[data.index]"
                :name="'kehadiran['+data.index+']'"
                value="hadir"
                :checked="data.value"
                :disabled="!data.item.editable"
                class="custom-control-primary"
            >
            </b-form-radio>
          </template>

          <!-- A custom formatted column -->
          <template #cell(sakit)="data">
            <b-form-radio
                v-model="selected[data.index]"
                :name="'kehadiran['+data.index+']'"
                value="sakit"
                :checked="data.value"
                class="custom-control-warning"
                :disabled="!data.item.editable"
            >
            </b-form-radio>
          </template>

          <!-- A custom formatted column -->
          <template #cell(izin)="data">
            <b-form-radio
                v-model="selected[data.index]"
                :name="'kehadiran['+data.index+']'"
                value="izin"
                :checked="data.value"
                :disabled="!data.item.editable"
                class="custom-control-info"
            >
            </b-form-radio>
          </template>
        </b-table>
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            :disabled="loading" @click="simpan">
          <b-spinner v-if="loading" small/>
          <span v-if="loading" class="sr-only">Loading...</span>
          <span v-else>Simpan</span>
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import {BTable, BProgress, BBadge, BCard, BFormRadio, BButton, BSpinner} from 'bootstrap-vue'
import axios from "axios";
import Ripple from "vue-ripple-directive";
import store from "@/store";

export default {
  components: {
    BTable,
    BProgress,
    BBadge,
    BCard,
    BFormRadio,
    BButton,
    BSpinner
  },
  data() {
    return {
      tanggalStr : '',
      loading: false,
      selected: [],
      tanggal: null,
      fields: [
        '#',
        {key: 'nama', label: 'Nama'},
        {key: 'unit_kerja', label: 'Unit Kerja'},
        {key: 'alfa', label: 'Alfa'},
        {key: 'hadir', label: 'Hadir'},
        {key: 'sakit', label: 'Sakit'},
        {key: 'izin', label: 'Izin'},
      ],
      items: [],
    }
  },
  directives: {
    Ripple,
  },
  async created() {
    this.tanggal = this.$moment(this.$route.params.tanggal).format("dddd, Do MMMM YYYY")
    this.tanggalStr = this.$route.params.tanggal;
    await this.getData(this.$route.params.tanggal);
  },
  methods: {
    async getData(tanggal) {
      await axios.get('/api/presensi/system/' + tanggal).then(response => {
        this.items = response.data.data

        this.items.map((item, index) => {
          if (item.alfa) {
            this.selected[index] = 'alfa'
          } else if (item.hadir) {
            this.selected[index] = 'hadir'
          } else if (item.sakit) {
            this.selected[index] = 'sakit'
          } else {
            this.selected[index] = 'izin'
          }
        })
      }).catch(error => {
        console.log('Error : ' + error.toString())
      })
    },
    setRadio(index, tipe) {
      this.items[index].alfa = true
      this.items[index].izin = true
      this.items[index].sakit = true
      this.items[index].hadir = true
      switch (tipe) {
        case 'izin' :
          this.items[index].alfa = false
          this.items[index].sakit = false
          this.items[index].hadir = false
          break
        case 'sakit' :
          this.items[index].alfa = false
          this.items[index].izin = false
          this.items[index].hadir = false
          break
        case 'alfa' :
          this.items[index].izin = false
          this.items[index].sakit = false
          this.items[index].hadir = false
          break
        case 'hadir' :
          this.items[index].alfa = false
          this.items[index].sakit = false
          this.items[index].izin = false
          break
      }
    },
    simpan() {
      this.$swal({
        title: 'Apa anda yakin?',
        text: "Anda memperbaharui presensi!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya!',
        cancelButtonText: 'Tidak',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.loading = true
          axios.post('/api/presensi/system/' + this.tanggalStr, {
            'models': this.items,
            'selected': this.selected
          }).then(response => {
            this.loading = false
            this.$swal({
              icon: 'success',
              title: 'Berhasil',
              text: 'Data berhasil di simpan',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            }).then(()=>{
              location.reload();
            })
          }).catch(error => {
            this.loading = false
            console.log('Error : ' + error.toString())
          })
        }
      })
    }
  },
  watch: {
    selected: {
      handler(val, oldVal) {
        if (val) {
          val.map((item, index) => {
            this.setRadio(index, item)
          })
        }
      }
    }
  }
}
</script>
